import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-base-modal",
  templateUrl: "./base-modal.component.html",
  styleUrls: ["./base-modal.component.scss"],
})
export class BaseModalComponent {
  @Input() isOpen = false;
  @Input() withOverlay = true;
  @Input() withHeader = true;

  @Output() close = new EventEmitter();
}
